import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { GrDrag } from "react-icons/gr";
const Container = styled.div`
    .invis{
        opacity:0.0;
    }
    .beingDragged{
        position:fixed;
        box-shadow: #AAA 0px 8px 12px -4px;
    }
    .dragger{
        cursor:grab;
    }
`;
const DragIcon = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    width:100%;
    height:100%;
    span{
        cursor:grab;
    }
    
`
export const DragHandle = ({handleClassName})=>{
    return <DragIcon><span className={handleClassName}><GrDrag /></span></DragIcon>
}
export const DragableList = (props)=>{
    const Component = props.component;
    const containerRef = useRef(null);
    const replaceItem = (fromIndex, toIndex)=>{
        const elem = containerRef.current.childNodes[fromIndex];
        if (fromIndex > toIndex){
            containerRef.current.insertBefore(elem, containerRef.current.childNodes[toIndex]);
        }else{
            containerRef.current.insertBefore(elem, containerRef.current.childNodes[toIndex].nextSibling);
        }
        
    }
    
    
    useEffect(() => {
        if(containerRef !== null){
            const childCount = containerRef.current.childElementCount;
            for (let index = 0; index < childCount; index++){
                let dragging = false;

                const element = containerRef.current.childNodes[index];                
                const dragger = element.querySelector(`.${props.handleClassName}`);
                
                if(dragger){
                    if (dragger.dataset.listener !== 'true'){
                        dragger.onmousedown = (e)=>{
                            dragger.style.cursor = 'grabbing';
                            if (window.getSelection) {window.getSelection().removeAllRanges();}
                            else if (document.selection) {document.selection.empty();}
                            let currentIndex = Array.from(element.parentNode.children).indexOf(element);
                            const initIndex = currentIndex;
                            
                            dragging = true;
                            document.body.className += ' non-selectable';
                            
                            const clonedNode = element.cloneNode(true);                            
                            clonedNode.className += ' beingDragged';
                            containerRef.current.appendChild(clonedNode);
                            const margin_top = parseFloat(window.getComputedStyle(element).marginTop);
                            clonedNode.style.top = `calc(${element.getBoundingClientRect().top}px - ${margin_top}px)`
    
                            clonedNode.style.width = window.getComputedStyle(element).width;
                            const diff = e.clientY - parseFloat(window.getComputedStyle(clonedNode).top);
                            element.className = element.className + " invis"
                            
                            function stopDragging(){
                                if (props.finishDrag(initIndex, currentIndex)){
                                    
                                }else{
                                    
                                    containerRef.current.childNodes[currentIndex].className += ' shake';
                                    
                                    setTimeout(() => {
                                        
                                        containerRef.current.childNodes[currentIndex].className = containerRef.current.childNodes[currentIndex].className.replace('shake', '')
                                        replaceItem(currentIndex, initIndex)
                                    }, 200);
                                }
                                dragger.style.cursor = 'grab';
                                dragging = false;
                                element.className = element.className.replaceAll(" invis", "");
                                document.body.className = document.body.className.replaceAll(' non-selectable', "");
                                try {
                                    containerRef.current.removeChild(clonedNode);
                                } catch (error) {
                                    
                                }
                            }
    
                            containerRef.current.onmousemove = (e) => {
                                if (dragging){
                                    if (e.clientY > containerRef.current.getBoundingClientRect().top && e.clientY < containerRef.current.getBoundingClientRect().bottom){
    
                                        const newTop = e.clientY - diff;
                                        clonedNode.style.top = `${newTop}px`;
                                        if (currentIndex < childCount - 1){
                                            if (newTop > element.nextSibling.getBoundingClientRect().top - (margin_top*2)){
                                                currentIndex += 1;
                                                containerRef.current.insertBefore(element.nextSibling, element);
                                            }
                                        }
                                        if (currentIndex > 0){
                                            if (newTop < element.previousElementSibling.getBoundingClientRect().top + (margin_top)){
                                                currentIndex -= 1;
                                                containerRef.current.insertBefore(element, element.previousElementSibling);
                                            }
                                        }
                                    }else{
                                        stopDragging();
                                    }   
                                }
                            }
                            containerRef.current.onmouseleave = () => {
                                if (dragging){
                                    stopDragging();
                                }
                                
                            }
                            document.onmouseup = ()=>{
                                if (dragging){
                                    stopDragging();
                                }
                                
                            }
                        }
                    }
                    dragger.dataset.listener = 'true';
                }
            }
        }
    }, [containerRef, props]);

    return (
        <Container ref={containerRef}>
          <Component />
        </Container>
    );
    
}